// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-list:hover:not(.csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-Mui-selected) {
	background-color: var(--Grey200);
	border-color: var(--Grey500);
}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-list:focus {
	background-color: var(--Grey200);
	outline: none;
}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-list:active:not(.csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-Mui-selected) {
	background-color: var(--NavListItemSelectedBG);
	border-color: var(--PrimaryDefault);
}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-Mui-selected {
	background-color: var(--NavListItemSelectedBG);
	border-color: var(--PrimaryDefault);
	color: var(--PrimaryDefault);
}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-list:hover:not(.csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-Mui-selected) .csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-showOnHover {
	visibility: visible;
}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-list .csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-showOnHover {
	visibility: hidden;
}

.csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-favoriteButton {
	margin-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/csi/middleware/customView/customViewLeftPanel/CustomViewDialogFavorites.module.css"],"names":[],"mappings":"AAAA;CACC,gCAAgC;CAChC,4BAA4B;AAC7B;;AAEA;CACC,gCAAgC;CAChC,aAAa;AACd;;AAEA;CACC,8CAA8C;CAC9C,mCAAmC;AACpC;;AAEA;CACC,8CAA8C;CAC9C,mCAAmC;CACnC,4BAA4B;AAC7B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf","sourcesContent":[".list:hover:not(.Mui-selected) {\n\tbackground-color: var(--Grey200);\n\tborder-color: var(--Grey500);\n}\n\n.list:focus {\n\tbackground-color: var(--Grey200);\n\toutline: none;\n}\n\n.list:active:not(.Mui-selected) {\n\tbackground-color: var(--NavListItemSelectedBG);\n\tborder-color: var(--PrimaryDefault);\n}\n\n.Mui-selected {\n\tbackground-color: var(--NavListItemSelectedBG);\n\tborder-color: var(--PrimaryDefault);\n\tcolor: var(--PrimaryDefault);\n}\n\n.list:hover:not(.Mui-selected) .showOnHover {\n\tvisibility: visible;\n}\n\n.list .showOnHover {\n\tvisibility: hidden;\n}\n\n.favoriteButton {\n\tmargin-left: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-list`,
	"Mui-selected": `csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-Mui-selected`,
	"muiSelected": `csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-Mui-selected`,
	"showOnHover": `csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-showOnHover`,
	"favoriteButton": `csi-middleware-customView-customViewLeftPanel-CustomViewDialogFavorites-module-favoriteButton`
};
module.exports = ___CSS_LOADER_EXPORT___;
